// Define layout-specific constants here
export const DRAWER_SIZES = {
  mobile: 300,
  desktop: 350,
};

export const ROUTES = {
  HOME: "/home",
  MARKETPLACE: "/marketplace",
  REFERRALS: "/referrals",
  PROFILE: "/profile",
  ADVENTURE: "/adventure/new",
  LANDS: "/lands",
  LOGIN: "/login",
  DAO: "/dao",
};

export const STORAGE_KEYS = {
  TOUR: "tour",
  USER_TOKEN: "user.token",
  REF_CODE: "refCode",
  CONNECTOR: "connector",
}; 